import { all, fork } from "redux-saga/effects";

import auth from "./auth";
import account from "./account";
import emission from "./emission";
import listings from "./listings";
import facility from "./facility";
import dashboard from "./dashboard";
import users from "./users";
import company from "./company";
import approval from "./approval";
import audit from "./audit";
import tickets from "./tickets";
import reports from "./reports";
import emissionComments from "./emissionComments";
import assessment from "./assessment";
import superAdmin from "./superAdmin";
import goalSettings from "./goalSettings";
import trade from "./trade";
import materiality from "./materiality";
import carbonOffset from "./carbonOffset";
import supplierScreening from "./supplierScreening";
import productionData from "./productionData";
import SustainabilityRiskAssessment from "./sustainabilityRiskAssessment";
/**
 * rootSaga
 */
export default function* root() {
  yield all([
    fork(auth),
    fork(account),
    fork(emission),
    fork(listings),
    fork(facility),
    fork(dashboard),
    fork(users),
    fork(company),
    fork(approval),
    fork(audit),
    fork(tickets),
    fork(reports),
    fork(emissionComments),
    fork(assessment),
    fork(superAdmin),
    fork(goalSettings),
    fork(trade),
    fork(materiality),
    fork(carbonOffset),
    fork(supplierScreening),
    fork(productionData),
    fork(SustainabilityRiskAssessment),
  ]);
}
